export function areSetsEqual<T>(a: Set<T>, b: Set<T>) {
  return a.size === b.size && Array.from(a).every(item => b.has(item));
}
